module.exports = __webpack_public_path__ + "static/img/per9.8f4277d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per9.jpg
// module id = IsLz
// module chunks = 41